import { useInView } from '../../../hooks/useInView';

const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20quero%20regularizar%20meu%20im%C3%B3vel.%20Poderia%20me%20ajudar%3F';

export default function CTASection() {
  const { ref, inView } = useInView();

  return (
    <section className="w-full py-20 md:py-28 relative overflow-hidden" style={{ background: '#123B73' }}>
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20abstract%20golden%20luxury%20geometric%20pattern%20dark%20navy%20blue%20background%20sophisticated%20premium%20legal%20corporate%20texture%20metallic%20gold%20lines%20on%20dark%20surface%20architectural%20details%20premium%20quality&width=1920&height=600&seq=uitalo-cta-bg1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(18,59,115,0.88)' }}></div>
      </div>

      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center transition-all duration-1000 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Ornament */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37)' }}></div>
          <i className="ri-building-2-line text-xl" style={{ color: '#D4AF37' }}></i>
          <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, #D4AF37, transparent)' }}></div>
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold leading-tight mb-6" style={{ color: '#F5F5F5' }}>
          Regularize seu imóvel com{' '}
          <span style={{ color: '#D4AF37' }}>segurança</span> e evite
          prejuízos futuros.
        </h2>

        <p className="font-sans text-base md:text-lg font-light leading-relaxed mb-10" style={{ color: '#D9D9D9' }}>
          Não deixe a irregularidade do seu imóvel comprometer seu patrimônio.
          Fale com um especialista agora mesmo e descubra a solução ideal para o seu caso.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-10 py-4 font-sans font-semibold text-sm tracking-wider uppercase whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
            style={{ background: '#D4AF37', color: '#0A2A52', borderRadius: '2px' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#C29B2E'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#D4AF37'; }}
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Solicitar Consultoria
          </a>
        </div>

        <p className="font-sans text-xs mt-6 font-light" style={{ color: 'rgba(217,217,217,0.6)' }}>
          Atendimento especializado · Resposta rápida · Sigilo garantido
        </p>
      </div>
    </section>
  );
}